import dayjs from 'dayjs'
import PropTypes from 'prop-types'

import { Badge } from '@/components/elements/badge'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/elements/card'

const formatDate = (value) => (value ? dayjs(value).format('MMM D, YYYY') : null)

const certRows = [
  { key: 'rescuex', label: 'RescueX Instructor' },
  { key: 'rescueReady', label: 'Rescue Ready Instructor' },
  { key: 'surfaceRescue', label: 'Surface Rescue Instructor' },
]

const certNumberKey = (key) => `${key}InstructorNumber`
const certExpirationKey = (key) => `${key}InstructorExpiration`

const isExpired = (date) => date && dayjs(date).isBefore(dayjs(), 'day')

const InstructorSection = ({ entityRole }) => {
  const { user } = entityRole
  const hasAnyCert = certRows.some(({ key }) => user[certNumberKey(key)])

  let xverseStatus = null
  if (user.isXverseInstructor) xverseStatus = { label: 'Active', variant: 'success' }
  else if (user.isXverseInstructorCandidate)
    xverseStatus = { label: 'Candidate', variant: 'warning' }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Instructor</CardTitle>
        <CardDescription>
          Teaching credentials, certification numbers, and expirations.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        {xverseStatus && (
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium">Xverse Instructor:</span>
            <Badge variant={xverseStatus.variant}>{xverseStatus.label}</Badge>
          </div>
        )}

        {hasAnyCert ? (
          <div className="divide-accent grid grid-cols-1 divide-y rounded-lg border-1">
            {certRows.map(({ key, label }) => {
              const number = user[certNumberKey(key)]
              const expiration = user[certExpirationKey(key)]
              if (!number) return null
              const expired = isExpired(expiration)
              return (
                <div
                  key={key}
                  className="flex flex-row items-center justify-between gap-4 px-4 py-3"
                >
                  <div className="flex flex-col">
                    <span className="text-sm font-medium">{label}</span>
                    <span className="text-muted-foreground font-mono text-xs">{number}</span>
                  </div>
                  <div className="flex flex-col items-end gap-1">
                    {expiration ? (
                      <>
                        <span className="text-muted-foreground text-xs">
                          Expires {formatDate(expiration)}
                        </span>
                        {expired && <Badge variant="destructive">Expired</Badge>}
                      </>
                    ) : (
                      <span className="text-muted-foreground text-xs italic">No expiration</span>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        ) : (
          <span className="text-muted-foreground text-sm italic">
            No instructor certifications issued yet.
          </span>
        )}
      </CardContent>
    </Card>
  )
}

InstructorSection.propTypes = {
  entityRole: PropTypes.shape({
    user: PropTypes.object.isRequired,
  }).isRequired,
}

export default InstructorSection
